<script setup>
import { ref, onMounted, watchEffect, computed } from "vue";
import Avatar from "./common/Avatar.vue";
import { useRouter } from "vue-router";
import { getUser } from "@/services/auth";

const isDropdownOpen = ref(false);
const router = useRouter();
const user = ref(null);

const userName = ref("");
const userEmail = ref("");
const userRole = ref("");

const roles = [
  { id: "1", label: "Administrador" },
  { id: "2", label: "Editor" },
];

const userRoleLabel = computed(() => {
  if (!user.value || !user.value.role) return "Usuario";
  return user.value.role === "role1" ? "Administrador" : "Editor";
});

const initials = computed(() => {
  if (!user.value || !user.value.name) return "GC";
  const [firstName, lastName] = user.value.name.split(" ");
  return `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase();
});

watchEffect(() => {
  if (user.value) {
    userName.value = user.value.name;
    userEmail.value = user.value.email;
  } else {
    userName.value = "";
    userEmail.value = "";
  }
});
//Traer datos del usuario
onMounted(async () => {
  const authToken = localStorage.getItem("authToken");
  try {
    user.value = await getUser(authToken);
    console.log("Usuario desde la API:", user.value);

    userName.value = user.value.name;
    userEmail.value = user.value.email;
    userRole.value = user.value.role.replace("role", "");
  } catch (error) {
    console.error(error);
  }
});

function toggleDropdown() {
  isDropdownOpen.value = !isDropdownOpen.value;
}

/* Click fuera del dropdown */
onMounted(() => {
  document.addEventListener("click", (event) => {
    if (
      !event.target.closest('.profile-dropdown-trigger') &&
      !event.target.closest('.profile-dropdown-menu')
    ) {
      isDropdownOpen.value = false;
    }
  });
});
/* Logout */
const logout = () => {
  isDropdownOpen.value = false;
  localStorage.removeItem("authToken");
  localStorage.removeItem("r");
  localStorage.removeItem("a");
  localStorage.clear();
  router.push("/login");
};

const isModalOpen = ref(false);

function handleClick() {
  isModalOpen.value = true;
}

function closeModal() {
  isModalOpen.value = false;
  location.reload();
}

/* const isEditing = ref(false); */

/* const saveChanges = () => {
  const roleToSave = `role${userRole.value}`;
  console.log("Cambios guardados:", {
    name: userName.value,
    email: userEmail.value,
    role: roleToSave,
  });
};

function handleEditClick() {
  isEditing.value = true;
} */
</script>
<template>
  <header class="header-container">
    <div class="header-left">
      <div class="header-title">Golden Contactability Platform</div>
      <div class="header-greeting">¡Hola, {{ user ? user.name : '' }}!</div>
    </div>
    <div class="header-right">
      <div class="profile-info profile-dropdown-trigger" @click="toggleDropdown">
        <Avatar :initials="initials" size="medium" />
        <div class="profile-details">
          <div class="profile-name">{{ user ? user.name : '' }}</div>
          <div class="profile-role">{{ userRoleLabel }}</div>
        </div>
        <i class="fa-solid fa-caret-down" style="font-size: 1rem; color: #888; margin-left: 0.5rem;"></i>
      </div>
      <div v-if="isDropdownOpen" class="profile-dropdown-menu">
        <button class="dropdown-item" @click="logout">Cerrar sesión</button>
      </div>
      <div class="notification-icon">
        <i class="fa-regular fa-bell"></i>
      </div>
    </div>
  </header>
  <!-- Modal -->
  <div class="modal" :class="{ show: isModalOpen }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div style="display: flex; flex-direction: row-reverse">
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div id="carouselExample" class="carousel slide">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div class="modal-header">
                  <div
                    class="d-flex gap-3 flex-column w-auto justify-content-evenly align-items-center"
                  >
                    <Avatar :initials="initials" size="large"></Avatar>
                    <h6 style="font-weight: 800; font-size: large">
                      {{ user ? user.name : "" }}
                    </h6>
                  </div>
                </div>
                <div class="d-flex w-100" style="font-weight: 600">
                  {{ userRoleLabel }}
                </div>
                <div class="d-flex w-100" style="font-weight: 600">
                  {{ user ? user.email : "" }}
                </div>
              </div>
              <div class="carousel-item">
                <form class="d-flex flex-column gap-3">
                  <div
                    class="d-flex gap-3 flex-column w-auto justify-content-evenly align-items-center"
                  >
                    <Avatar :initials="initials" size="large"></Avatar>
                    <div class="d-flex gap-2" style="text-align: center">
                      <label
                        for="userName"
                        class="form-label fw-semibold mt-2"
                        style="width: 5rem"
                        >Nombre:</label
                      >
                      <input
                        id="userName"
                        class="form-control globals-input px-2"
                        v-model="userName"
                      />
                    </div>
                  </div>

                  <div class="d-flex gap-2" style="text-align: center">
                    <label
                      for="userRole"
                      class="form-label fw-semibold mt-2"
                      style="width: 5rem; text-align: left"
                      >Usuario:</label
                    >
                    <select
                      id="userRole"
                      class="form-select form-select-details"
                      v-model="userRole"
                    >
                      <option value="">Selecciona un tipo de usuario</option>
                      <option
                        v-for="role in roles"
                        :key="role.id"
                        :value="role.id"
                      >
                        {{ role.label }}
                      </option>
                    </select>
                  </div>

                  <div class="d-flex gap-2" style="text-align: center">
                    <label
                      for="userEmail"
                      class="form-label fw-semibold mt-2"
                      style="width: 5rem; text-align: left"
                      >Email:</label
                    >
                    <input
                      id="userEmail"
                      class="form-control globals-input px-2 w-100"
                      v-model="userEmail"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div class="d-flex justify-content-evenly gap-4 my-4 w-100 mt-6">
              <button class="globals-border-button" @click="closeModal">
                Cerrar
              </button>
              <!-- <button
                v-if="!isEditing"
                type="button"
                class="globals-button"
                @click="handleEditClick"
                data-bs-target="#carouselExample"
                data-bs-slide="next"
              >
                Editar
              </button>
              <button
                v-else
                type="button"
                class="globals-button"
                @click="saveChanges"
              >
                Guardar cambios
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
li {
  margin: 1rem 0;
}
.li-option {
  margin: 1rem 0;
  padding: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.li-option :hover {
  background-color: rgba(0, 0, 0, 0.1);
  transform: scale(1.05);
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 2;
}

.show {
  display: block;
}
/* Modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $shadow-color;
  backdrop-filter: blur(10px);
  display: none;
}

.modal.show {
  display: block;
}

.modal-dialog {
  max-width: 600px;
  margin: 40px auto;
  background-color: $ultra-white-color;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 0 10px $shadow-color;
}

.modal-content {
  display: flex;
  justify-content: center;
  padding: 20px;
  border: none;
}

.modal-header {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: none;
}

.modal-title {
  font-weight: bold;
  font-size: 18px;
}
.modal-body {
  display: flex;
  flex-direction: column;
}

.btn-close {
  background-color: transparent;
  border: none;
  padding: 2%;
  font-size: 13px;
  cursor: pointer;
}

.btn-close:hover {
  background-color: $seven-color;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  margin-bottom: 1.5rem;
}

.header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.header-title {
  font-size: 2rem;
  font-weight: 700;
  color: #007080;
}

.header-greeting {
  font-size: 1rem;
  color: #444;
  margin-top: 0.2rem;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  position: relative;
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  cursor: pointer;
  position: relative;
}

.profile-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.profile-name {
  font-weight: 600;
  font-size: 1rem;
}

.profile-role {
  font-size: 0.9rem;
  color: #888;
}

.notification-icon {
  font-size: 1.5rem;
  color: #007080 !important;
  cursor: pointer;
}

.profile-dropdown-menu {
  position: absolute;
  top: 60px;
  right: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
  min-width: 160px;
  z-index: 1000;
  padding: 0.5rem 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.dropdown-item {
  width: 100%;
  background: none;
  border: none;
  padding: 0.75rem 1.5rem;
  text-align: left;
  color: #007080;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}
.dropdown-item:hover {
  background: #f6f5f8;
}
</style>
